module.exports = __webpack_public_path__ + "img/ai-task-extraction.adf06e06.svg";